import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getTaskMap } from "@/utils/dictionary";
export default {
  data: function data() {
    return {
      taskOptions: [],
      label: this.value
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res1, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getTaskMap();
            case 2:
              res1 = _context.sent;
              for (index in res1) {
                _this.taskOptions.push({
                  task_id: index,
                  task_name: res1[index]
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    someSelect: function someSelect() {
      this.$emit("input", this.label);
    }
  }
};